<template>
	<div class="row items flex-row">
		<div class="columns column12">
			<transition-group
				ref="container"
				:style="{ minHeight: `${containerHeight}px` }"
				class="gallery-wrapper flex-row"
				tag="div"
				name="gallery"
				@after-enter="updateHeight"
				@before-leave="updateHeight"
			>
				<div
					v-for="item in items"
					:key="item.ID"
					class="filter-item"
					:class="{ active: filter === item.galleryCategorie.ID || filter === 'showAll' }"
				>
					<gallery-item :item="item" />
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

const containerHeight = ref('265');

const updateHeight = (el) => {
	const item = el.querySelector('.gallery-item');
	containerHeight.value = item.offsetHeight;
};

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss">
.gallery-move {
	transition: transform 0.5s;
}

.gallery-enter-active {
	transition: all 0.3s ease-out;
}

.gallery-leave-active,
.gallery-enter-from {
	position: absolute;
	opacity: 0;
}

.gallery-enter-from {
	transform: translateY(10px);
}
</style>

<style lang="scss" scoped>
.items > .column12 {
	float: none;
}

.row {
	overflow: visible;
}

.gallery-wrapper {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 50px;
	margin: 50px 0 100px;
}

@media (max-width: 960px) {
	.gallery-wrapper {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 500px) {
	.gallery-wrapper {
		grid-template-columns: 1fr;
	}
}
</style>
